import Button from '__components/Button';
import useModal from '__components/Modals/useModal';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CreateScheduleModal } from './CreateScheduleModal';
import { generateCSV } from 'pages/SmartConnectors/SmartConnector/helpers';

type CreateScheduleButtonProps = {
  fileInputRef: React.RefObject<HTMLInputElement>;
};

// format: schedule-sample-YYYY-MM-DD_hh-mm-ss.csv
const getCSVFileName = () =>
  `schedule-sample-${new Date()
    .toLocaleDateString('en')
    .split('/')
    .join(
      '-'
    )}_${new Date().toLocaleTimeString('en', { hour12: false }).split(':').join('-')}.csv`;

export const CreateScheduleButton: FC<CreateScheduleButtonProps> = ({
  fileInputRef,
}) => {
  const { t } = useTranslation();

  const [modalProps, { onClick }] = useModal({
    handleSubmit: (date: Date) => {
      if (fileInputRef.current) {
        const csvText = generateCSV([
          ['schedule_trigger_time'],
          [date.toISOString()],
        ]);

        const dataTransfer = new DataTransfer();
        const file = new File(
          [new Blob([csvText], { type: 'text/csv;charset=utf-8' })],
          getCSVFileName()
        );
        dataTransfer.items.add(file);

        fileInputRef.current.focus();
        fileInputRef.current.files = dataTransfer.files;
        fileInputRef.current.dispatchEvent(
          new Event('change', { bubbles: true })
        );
        fileInputRef.current.blur();
      }
    },
  });

  return (
    <>
      <Button variant="outline" color="blue" onClick={onClick}>
        {t('Generate Sample File')}
      </Button>
      {modalProps.show ? <CreateScheduleModal {...modalProps} /> : null}
    </>
  );
};
